import { IApplication } from "../Application/Application";
import { IBaseModel } from "../BaseModel";

export enum CustomerApplicationStatus {
  Archived,
  Disabled,
  Enabled,
}

export interface ICustomerApplication extends IBaseModel {
  customerId: string;
  clientSecret: string;
  status: CustomerApplicationStatus;
  applicationId: string;
  application: IApplication;
  applicationSettingsMissingValuesCount: number;
  applicationSettingsConnectionString: string;
}
